import { baseMarkPattern } from './__base'
export const em = function em (text) {
  if (text.startsWith('— ')) {
    // This is a citation
    return baseMarkPattern(text.substring(2), '??')
  }
  return baseMarkPattern(text, '{_}')
}
